import { makeAutoObservable } from "mobx"

class ModalStore {

  invest_calc_quote = false
  header_Talk2Expert = false
  quote_whatsapp = false
  quote_fundBd = false
  quote_fundBdData = []
  quote_staticFP = false
  quote_taxSavings = false
  quote_extraBen = false
  planWorks_Video = false

  constructor() {
    makeAutoObservable(this)
  }

  setInvestCalcQuote = (data) => (this.invest_calc_quote = data)
  setTalk2Expert = (data) => (this.header_Talk2Expert = data)
  setWhatsappModal = (data) => (this.quote_whatsapp = data)

  setQuoteFundBd = (data) => (this.quote_fundBd = data)
  setQuoteFundBdData = (data) => (this.quote_fundBdData = data)
  setQuoteStaticFP = (data) => (this.quote_staticFP = data)

  setQuoteTaxSavings = (data) => (this.quote_taxSavings = data)
  setQuoteExtraBen = (data) => (this.quote_extraBen = data)

  setPlanWorksVideo = (data) => (this.planWorks_Video = data)
}

export default new ModalStore()
